import React from 'react';
import Icon from '@pushpay/icon';

const DownArrowIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C12.8834464,6 13.6000324,6.7757551 13.6000324,7.73297959 L13.6000324,12.5 C13.6000324,12.7398367 13.7794646,12.9329796 14.0000405,12.9329796 L15.2000647,12.9329796 C15.5074995,12.9329796 15.7875052,13.124 15.9212222,13.4243265 C16.0537963,13.7235918 16.0172241,14.0801633 15.8252202,14.3401633 L12.6251555,18.6731429 C12.4742953,18.8800816 12.2434335,19 12,19 C11.7565665,19 11.5257047,18.8800816 11.3748445,18.6731429 L8.17477977,14.3401633 C7.98277589,14.0801633 7.94620372,13.7235918 8.07877783,13.4243265 C8.21249482,13.124 8.49364336,12.9329796 8.80107815,12.9329796 L9.99995955,12.9329796 C10.2216783,12.9329796 10.3999676,12.7398367 10.3999676,12.5 L10.3999676,7.73297959 C10.3999676,6.7757551 11.1165536,6 12,6",
    fill: "currentColor"
  }));
};

export default DownArrowIcon;